import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ImportantDevicesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"important_devices"}/>
}
